module.exports = __webpack_public_path__ + "img/icon_Site_G.f2fb6959.svg";